<template>
  <div class="main_order_create_home">
    <div class="main_create_header" style="width:100%;height:80px;background:#0072ff;">
        <h1 style="font-size:25px;height:100%;line-height:80px;text-align:center;color:white;">
            发布申请预约
        </h1>
    </div>
    <a-spin tip="加载中..." 
    style="width:100%;text-align:center;margin-top:20px;margin-bottom:20px;" 
    :spinning="loading">
    </a-spin>
    <div class="main_create_content" v-if="!loading">
        <ul style="display:grid;margin:0;padding:0;">
            <li style="width:100%;height:40px;margin-top:40px" v-if="user.hasOwnProperty('customer') && user.customer.hasOwnProperty('identifier') && user.customer.identifier">
                <span style="float:left;color:red;text-align:left;width:100%;height:40px;display:block;">
                    信息将覆盖当前登录用户的名字,联系方式和身份证号
                </span>
            </li>
            <li style="width:100%;height:70px;" v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier')">
                <a-input addon-before="车牌号" ref="userOrigPasswordInput" placeholder="请输入车牌号" v-model="order.auto.license_plate" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="车型" ref="userOrigPasswordInput" placeholder="请输入车型    (例如: 宝马X6)" v-model="order.auto.model" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;" v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier')">
                <a-input addon-before="VIN（车架号）" ref="userOrigPasswordInput" placeholder="请输入VIN（车架号）" v-model="order.auto.vin_no" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;" v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier')">
                <a-input addon-before="里程表显示" ref="userOrigPasswordInput" placeholder="请输入里程表显示" v-model="order.auto.meter_mileage" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:90px;" v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier')">
                <span style="text-align:left;width:100%;display:block;margin-top:20px;font-size:16px;">检测类型</span>
                <a-radio-group style="margin:0;padding:0;margin-top:20px;" :defaultValue="order.menu.mode" @change="onDetectModeChange">
                    <li style="float:left;">
                        <a-radio value="BASE">基础检测</a-radio>
                    </li>
                    <li style="float:left;">
                        <a-radio value="COMPREHENSIVE">全面检测</a-radio>
                    </li>
                    <li style="float:left;">
                        <a-radio value="EVALUATE">评估检测</a-radio>
                    </li>
                </a-radio-group>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="联系人" ref="userOrigPasswordInput" placeholder="请输入联系人" v-model="order.customer.name" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="联系方式" ref="userOrigPasswordInput" placeholder="请输入联系方式" v-model="order.customer.mobile" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;">
                <a-input addon-before="身份证号" ref="userOrigPasswordInput" placeholder="请输入身份证号" v-model="order.customer.idcard_no" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;" v-if="user.hasOwnProperty('inspector') && user.inspector.hasOwnProperty('identifier') && user.inspector.identifier">
                <a-input addon-before="排量" type="number" ref="userOrigPasswordInput" placeholder="请输入排量" v-model="order.auto.displacement" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-select slot="addonAfter" v-model="order.auto.displacement_unit" default-value="L" style="width: 60px">
                        <a-select-option value="L">
                            L
                        </a-select-option>
                        <a-select-option value="T">
                            T
                        </a-select-option>
                    </a-select>
                </a-input>
            </li>
            <li style="width:100%;height:150px;">
                <span style="text-align:left;width:100%;display:block;margin-top:20px;font-size:16px;">备注</span>
                <a-textarea 
                :autoSize=false
                ref="userOrigPasswordInput" placeholder="请输入备注" v-model="order.remark" style="width:100%;height:100px;margin-top:20px;">
                    <a-icon type="user" />
                </a-textarea>
            </li>
            <li style="width:100%;height:70px;margin-top:40px;">
                <router-link to="/order/price">
                    点击查看收费标准
                </router-link>
            </li>
            <li style="width:100%;height:70px;margin-top:20px;">
                <a-button @click="createOrder" :loading="commit_loading" style="border-radius:5px;background:#1890ff;font-weight:bold;display:block;width:100%;height:50px;line-height:50px;margin-top:20px;color:white;font-size:20px;text-align:center;">
                    提交
                </a-button>
            </li>
        </ul>
    </div>
    <div style="width:100%;height:70px;margin-top:50px;text-align:center;">
        <span style="line-height:70px;text-align:center">
            {{ company.copyright_no }} 版权所有
        </span>
        <a style="text-align: center;width:100%;line-height: 20px;height:20px;display:block;" href="https://beian.miit.gov.cn" target="_blank">{{ company.record_no }}</a>
    </div>
  </div>
</template>

<script>
import OrderModel from '../../model/order'
import request from '../../api/request'
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'OrderCreate',
    head: {
        title: "发起申请预约",
        meta:[
            { name: 'description', content: '发起申请预约'}
        ]
    },
    data: function() {
        return {
            order: OrderModel,
            orderArgument: {
                id: 0,
                click_name: "点击上传",
                key: "order",
                accept: ".png, .jpg, .jpeg, .gif, .bmp",
                max_file_count: 9999999999,
                unlimit_count: true,
                fileList: [],
            },
            commit_loading: false,
            company: company_model,
            user:{},
            use_user_info: false,
            has_user_info: false,
            loading: false,
        }
    },
    methods: {
        fetch_user_info() {
            this.loading = true
            var user_info_resp = request.site_user.userinfo()
            user_info_resp.then((response) => {
                this.loading = false
                var failed_message = "获取用户信息失败，请重新登录"
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.user = response.data.data
                        if (this.user && this.user.customer && this.user.customer.identifier) {
                            this.use_user_info = false
                            if ((this.user.name && this.user.mobile) || (this.user.customer.name && this.user.customer.mobile)) {
                                this.use_user_info = true
                            }
                            
                            this.order.customer = this.user.customer
                            this.has_user_info = this.use_user_info
                            console.log(this.use_user_info)
                        }
                    }
                }
                else {
                    if (response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        onDetectModeChange(e) {
            this.order.menu.mode = e.target.value
        },
        createOrder() {
            
            var create_order_resp = undefined
            if (this.user.customer && this.user.customer.identifier) {
                if (!this.order.customer.mobile) {
                    this.$message.error("请输入联系方式!!!")
                    return undefined
                }
                this.commit_loading = true
                create_order_resp = request.order.pre_create(
                    this.orderArgument.fileList, 
                    this.order.auto.license_plate, 
                    this.order.auto.vin_no, 
                    this.order.auto.model,
                    this.order.auto.meter_mileage, 
                    this.order.auto.displacement, 
                    this.order.auto.displacement_unit,
                    this.order.customer.name, 
                    this.order.customer.mobile, 
                    this.order.customer.idcard_no, 
                    this.order.remark, 
                    this.order.menu.mode,
                    this.use_user_info
                )
                create_order_resp.then((response) => {
                    this.commit_loading = false
                    var pre_failed_message = "申请预约失败"
                    var pre_success_message = "申请预约成功"
                    if (response.status == 200 && response.data.code == 0) {
                        if (response.data && response.data.message) {
                            pre_success_message = response.data.message
                        }
                        this.$message.success(pre_success_message)
                        this.$router.push({
                            name: 'OrderList',
                        });
                    }
                    else {
                        if (response.data.message != null && response.data.message != undefined) {
                            pre_failed_message = response.data.message
                        }
                        this.$message.error(pre_failed_message)
                    }
                })
                .catch((error) => {
                    this.commit_loading = false
                    if (error) {
                        this.$error({
                            title: "请求失败，请联系管理员",
                            content: String(error),
                        });
                    }
                })
            }
            else {
                this.commit_loading = true
                create_order_resp = request.order.create(
                    this.orderArgument.fileList, 
                    this.order.auto.license_plate, 
                    this.order.auto.vin_no, 
                    this.order.auto.model,
                    this.order.auto.meter_mileage, 
                    this.order.auto.displacement, 
                    this.order.auto.displacement_unit,
                    this.order.customer.name, 
                    this.order.customer.mobile, 
                    this.order.customer.idcard_no, 
                    this.order.remark, 
                    this.order.menu.mode,
                )
                create_order_resp.then((response) => {
                    this.commit_loading = false
                    var failed_message = "申请预约失败"
                    var success_message = "申请预约成功"
                    if (response.status == 200 && response.data.code == 0) {
                        if (response.data && response.data.message) {
                            success_message = response.data.message
                        }
                        this.$message.success(success_message)
                        this.$router.push({
                            name: 'OrderList',
                        });
                    }
                    else {
                        if (response.data.message != null && response.data.message != undefined) {
                            failed_message = response.data.message
                        }
                        this.$message.error(failed_message)
                    }
                })
                .catch((error) => {
                    this.commit_loading = false
                    if (error) {
                        this.$error({
                            title: "请求失败，请联系管理员",
                            content: String(error),
                        });
                    }
                })
            }
            
            
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_company()
            this.fetch_user_info()
        }
    },
    created() {
        this.load()
    },
    components: {
    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_edit_home {
    margin: 0;
    padding: 0;
}

.main_create_content {
    margin: 0;
    padding: 0;
    margin-left: 5%;
    margin-right: 5%;
    margin-bottom: 0;
    margin-top: 30px;
}

.main_content > ul {
    margin: 0;
    padding: 0;
}

.edit_footer {
    background: #99999999;
    display: block;
    width: 100%;
    height: 50px;
    margin: 0;
    padding: 0;
}

.edit_footer span {
    padding: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    line-height: 50px;
}

</style>
